import colors from "@infobis/ui-styles-utils/styles/_colors";
import React from "react";
import soilImage from '@assets/images/partners/uralchem/activities/soil.png';
import greenMassImage from '@assets/images/partners/uralchem/activities/green-mass.png';
import waterImage from '@assets/images/partners/uralchem/activities/water.png';
import organicFertilizersImage from '@assets/images/partners/uralchem/activities/organic-fertilizers.png';

export const servicePacks = [
    {
        heading: 'Минимальный',
        id: 'min',
        list: [
            'органическое вещество (по Тюрину)',
            'азот легкогидролизуемый',
            'по Корнфилду',
            'подвижные соединения фосфора',
            'и калия',
            'pH',
        ],
        children: <p style={{color: colors.TYPO_SECONDARY}}>Минеральные формы азота — нитратный и аммонийный
            вынесены в персональный пакет</p>,
    },
    {
        heading: 'Оптимальный',
        id: 'opt',
        list: [
            'органическое вещество (по Тюрину)',
            'азот легкогидролизуемый',
            'по Корнфилду',
            'подвижные соединения фосфора',
            'и калия',
            'pH',
        ],
        filled: true,
        children: <p><b>+ ЕКО, подвижные соединения серы</b></p>,
    },
    {
        heading: 'Максимальный',
        id: 'max',
        listTitle: 'Полный анализ',
        list: [
            'гидролитическая кислотность/щелочность',
            'емкость катионного обмена',
            'органическое вещество (по Тюрину)',
            'азот легкогидролизуемый по Корнфилду',
            'подвижные соединения фосфора и калия',
            'микроэлементы и тяжелые металлы',
            'pH',
        ],
    },
    {
        heading: 'Персональный',
        id: 'config',
        list: [
            'минеральный азот',
            'кислотность',
            'микроэлементы',
            'загрязнение почв (тяжелые металлы)',
        ],
    },
];

export const staff = [
    {
        icon: (
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M50 57.8079C57.8565 57.8079 64.2262 51.4382 64.2262 43.5817C64.2262 35.7251 57.8565 29.3554 50 29.3554C42.1434 29.3554 35.7737 35.7251 35.7737 43.5817C35.7829 51.4346 42.1471 57.7987 50 57.8079ZM50 33.9445C55.3215 33.9445 59.6371 38.2601 59.6371 43.5817C59.6371 48.9032 55.3215 53.2188 50 53.2188C44.6784 53.2188 40.3628 48.9032 40.3628 43.5817C40.3702 38.262 44.6803 33.9519 50 33.9445ZM45.4347 45.5568L44.7941 47.5228C44.7225 47.7357 44.6821 47.9799 44.6821 48.2332C44.6821 49.4998 45.7101 50.5277 46.9767 50.5277C47.4833 50.5277 47.9514 50.3644 48.3314 50.0854L48.324 50.089L50 48.872L51.6759 50.089C52.0486 50.3625 52.5166 50.5259 53.0233 50.5259C54.2899 50.5259 55.3178 49.498 55.3178 48.2314C55.3178 47.978 55.2775 47.7339 55.2004 47.5044L55.2059 47.521L54.5671 45.555L56.2412 44.338C56.8176 43.9158 57.1884 43.2421 57.1884 42.4803C57.1884 41.2137 56.1604 40.1857 54.8938 40.1857H52.8214L52.1807 38.2179C51.7989 37.3754 50.9655 36.8008 50 36.8008C49.0344 36.8008 48.1992 37.3754 47.8247 38.2032L47.8192 38.2179L47.1786 40.1857H45.108C43.8414 40.1857 42.8134 41.2119 42.8134 42.4803C42.8134 43.2402 43.1824 43.9139 43.7533 44.3324L43.7606 44.3361L45.4347 45.5568ZM63.7122 60.2181C68.5253 56.2329 71.5688 50.2561 71.5688 43.5688C71.5688 31.6573 61.9115 22 50 22C38.0885 22 28.4312 31.6573 28.4312 43.5688C28.4312 50.2561 31.4747 56.2311 36.251 60.1869L36.2877 60.2163L31.3058 74.9694C31.2287 75.1896 31.1846 75.4411 31.1846 75.7054C31.1846 76.972 32.2126 78 33.4792 78C33.7398 78 33.9895 77.9559 34.2226 77.877L34.2061 77.8825L50.0018 72.6197L65.7975 77.8825C66.0141 77.9578 66.2638 78 66.5226 78C67.7892 78 68.8153 76.9739 68.8153 75.7073C68.8153 75.4429 68.7713 75.1915 68.6887 74.9547L68.6942 74.9712L63.7122 60.2181ZM33.0203 43.5817C33.0203 34.2034 40.6217 26.602 50 26.602C59.3783 26.602 66.9797 34.2034 66.9797 43.5817C66.9797 52.96 59.3783 60.5614 50 60.5614C40.6272 60.5504 33.0313 52.9545 33.0203 43.5835V43.5817ZM50.7251 68.0214C50.5084 67.9462 50.2588 67.904 49.9981 67.904C49.7375 67.904 49.4897 67.948 49.2565 68.0269L49.2731 68.0214L37.1284 72.069L40.2582 62.799C43.0888 64.2804 46.4425 65.1505 49.9981 65.1505C53.5538 65.1505 56.9075 64.2804 59.8574 62.744L59.7399 62.8009L62.8697 72.0709L50.7251 68.0214Z"
                    fill="#008B54"/>
                <rect x="2" y="2" width="96" height="96" rx="48" stroke="#008B54" strokeWidth="4"/>
            </svg>
        ),
        text: <p>Персонал лаборатории имеет <b>большой опыт работы и высокую квалификацию по агрохимии</b></p>,
    },
    {
        icon: (
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M76.5093 34.4922L50.8069 24.8006C50.5664 24.7069 50.2873 24.6519 49.9972 24.6519C49.7072 24.6519 49.4281 24.7069 49.1711 24.8042L49.1876 24.7987L23.4852 34.4904C22.6095 34.8282 22 35.6617 22 36.6383C22 37.615 22.6095 38.4485 23.4687 38.7808L23.4852 38.7863L25.6718 39.6106V62.8475L22.8867 67.0241C22.6444 67.3821 22.5012 67.8227 22.5012 68.2964C22.5012 68.77 22.6462 69.2125 22.8922 69.5778L22.8867 69.5705L26.0573 74.3254C26.4741 74.9441 27.1735 75.348 27.9666 75.348C28.7597 75.348 29.4592 74.9459 29.8704 74.3346L29.8759 74.3272L33.0465 69.5723C33.2889 69.2143 33.4321 68.7737 33.4321 68.3C33.4321 67.8264 33.287 67.3839 33.041 67.0186L33.0465 67.0259L30.2615 62.8493V41.3419L34.574 42.9685L31.62 60.8023C31.5998 60.9161 31.5888 61.0446 31.5888 61.1786C31.5888 62.1553 32.2002 62.9906 33.0594 63.3211L33.0759 63.3266C38.0768 65.302 43.8691 66.4568 49.9293 66.4788H49.9385C56.0465 66.4495 61.8773 65.2965 67.2454 63.2183L66.9149 63.3303C67.7943 62.998 68.4093 62.1627 68.4093 61.1841C68.4093 61.0666 68.4002 60.951 68.3836 60.8372L68.3855 60.85L65.7785 42.8363L76.5148 38.7882C77.3905 38.4504 78 37.6169 78 36.6402C78 35.6635 77.3905 34.83 76.5313 34.4977L76.5148 34.4922H76.5093ZM27.9666 68.9169L27.5536 68.3L27.9666 67.6832L28.3797 68.3L27.9666 68.9169ZM63.5699 59.6365C59.5181 61.0575 54.8477 61.8799 49.9844 61.8799C45.145 61.8799 40.4947 61.0666 36.1657 59.5686L36.4631 59.6585L38.9544 44.6189L49.1876 48.478C49.4281 48.5716 49.7072 48.6248 49.9972 48.6248C50.2873 48.6248 50.5664 48.5716 50.8234 48.4725L50.8069 48.478L61.3779 44.4923L63.5699 59.6365ZM49.9972 43.8772L30.7994 36.6402L49.9972 29.4013L69.1951 36.6402L49.9972 43.8772Z"
                    fill="#008B54"/>
                <rect x="2" y="2" width="96" height="96" rx="48" stroke="#008B54" strokeWidth="4"/>
            </svg>
        ),
        text: <p>Ежегодно сотрудники проходят <b>повышение квалификации по различным темам</b>, связанным с
            агрохимическим анализом</p>,
    },
    {
        icon: (
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M50.0805 59.9429C59.2979 59.9833 67.0014 66.4368 68.984 75.0844L69.0096 75.2166C69.0426 75.3635 69.0627 75.5324 69.0627 75.705C69.0627 76.9718 68.0375 78 66.7744 78C65.6833 78 64.7698 77.2326 64.541 76.2081L64.5373 76.1934C63.027 69.4773 57.1286 64.5347 50.0805 64.5347C43.0325 64.5347 37.1323 69.4773 35.6421 76.0961L35.6238 76.1952C35.3913 77.2344 34.4796 77.9982 33.3886 77.9982C32.1254 77.9982 31.1002 76.9718 31.1002 75.7032C31.1002 75.5287 31.1204 75.3598 31.157 75.1964L31.1533 75.2111C33.1634 66.435 40.865 59.9814 50.0769 59.9429H50.0805ZM62.595 41.0063C57.3629 41.0063 53.1194 36.7523 53.1194 31.5032C53.1194 26.254 57.3611 22 62.595 22C67.827 22 72.0705 26.254 72.0705 31.5032C72.0632 36.7486 67.8233 40.999 62.595 41.0063ZM62.595 26.59C59.8892 26.59 57.6961 28.7895 57.6961 31.5032C57.6961 34.2168 59.8892 36.4163 62.595 36.4163C65.3007 36.4163 67.4938 34.2168 67.4938 31.5032C67.4902 28.7914 65.2989 26.5937 62.595 26.59ZM37.4014 41.0063C32.1693 41.0063 27.9259 36.7523 27.9259 31.5032C27.9259 26.254 32.1675 22 37.4014 22C42.6334 22 46.8769 26.254 46.8769 31.5032C46.8696 36.7486 42.6316 40.999 37.4032 41.0063H37.4014ZM37.4014 26.59C34.6957 26.59 32.5025 28.7895 32.5025 31.5032C32.5025 34.2168 34.6957 36.4163 37.4014 36.4163C40.1071 36.4163 42.3002 34.2168 42.3002 31.5032C42.2966 28.7914 40.1053 26.5937 37.4014 26.59ZM22.0513 56.8547C23.633 49.3069 30.216 43.7199 38.1007 43.7199C38.8238 43.7199 39.5359 43.7677 40.2334 43.8576L40.151 43.8485C41.8535 39.9635 45.6558 37.2976 50.0805 37.2976C54.4998 37.2976 58.3002 39.9561 59.9789 43.7677L60.0064 43.8374C60.4934 43.775 61.0682 43.7328 61.6503 43.7218H61.6668C69.5936 43.7567 76.2169 49.3051 77.9249 56.7391L77.9469 56.8529C77.9799 56.9998 78 57.1705 78 57.3449C78 58.6136 76.9748 59.6418 75.7098 59.6418C74.6188 59.6418 73.7071 58.8762 73.4764 57.8517L73.4728 57.837C72.2206 52.3639 67.4151 48.3375 61.6686 48.3155C61.405 48.3155 61.1506 48.3522 60.8924 48.3687C60.7899 54.277 55.9881 59.0267 50.0824 59.0267C44.1803 59.0267 39.3822 54.2825 39.2723 48.3889V48.3779C38.9593 48.354 38.6517 48.3136 38.3314 48.3136C32.5831 48.3357 27.7776 52.3602 26.5382 57.7507L26.5217 57.8333C26.2911 58.8743 25.3776 59.6399 24.2865 59.6399C23.0233 59.6399 22 58.6136 22 57.3468C22 57.1742 22.0183 57.0053 22.0549 56.8437L22.0513 56.8584V56.8547ZM50.0805 54.4349C50.0805 54.4349 50.0805 54.4349 50.0824 54.4349C53.5368 54.4349 56.3378 51.6258 56.3378 48.1612C56.3378 44.6967 53.5368 41.8876 50.0824 41.8876C46.6279 41.8876 43.827 44.6967 43.827 48.1612C43.827 48.1612 43.827 48.1612 43.827 48.1631C43.8325 51.6258 46.6279 54.4294 50.0805 54.4349Z"
                    fill="#008B54"/>
                <rect x="2" y="2" width="96" height="96" rx="48" stroke="#008B54" strokeWidth="4"/>
            </svg>
        ),
        text: <p>Сотрудники агролаборатории находятся <b>в тесном взаимодействии с агрономами-консультантами
            компании</b></p>,
    }
];

export const advantages = [
    'Широкий спектр агро-химических анализов почвы, грунтов, зеленой массы растений, кормов',
    'Высокое качество выполнения анализов и получаемых результатов',
    'Оперативное получение результатов анализов',
    'Получение профес-сиональных консульта-ций и рекомендаций по результатам анализов',
];


export const ActivityTypes = {
    soil: 'soil',
    water: 'water',
    greenMass: 'greenMass',
    organicFertilizers: 'organicFertilizers',
} as const;

export const activityTabs = [
    {
        id: ActivityTypes.soil,
        label: 'Почвы/грунты',
    },
    {
        id: ActivityTypes.greenMass,
        label: 'Зеленая масса растений/корма',
    },
    {
        id: ActivityTypes.organicFertilizers,
        label: 'Органические удобрения',
    },
    {
        id: ActivityTypes.water,
        label: 'Поливные воды',
    },
]

export const activities = {
    [ActivityTypes.soil]: {
        heading: 'Почвы и грунты',
        directionsCount: <><span style={{fontWeight: 800}}>8+</span> направлений анализа</>,
        determinedIndicators:
            [
                'рН, удельная электрическая проводимость, плотный остаток водной вытяжки',
                'Щелочность карбонатных почв',
                'Органическое вещество',
                'Содержание мезоэлементов (кальций, магний, сера)',
                'Сумма поглощенных оснований, ЕКО, гидролитическая кислотность',
                'Содержание микроэлементов (Zn, Cu, Mn, Co, B, Mo)',
                'Содержание тяжелых металлов (Pb, Cd, Hg, Ni, Sn, V, Sb, As)',
                'Содержание макроэлементов (азот в нитратной и аммонийной форме, фосфор, калий)',
                'pH сол.',
            ],
        type:
            'violet',
        text:
            (
                <div style={{display: 'flex', justifyContent: 'space-between', gap: '104px'}}>
                    <p>На основании данных об агрохимических характеристиках почвы возможна <b>разработка
                        индивидуальной и
                        наиболее эффективной системы применения удобрений и мелиорантов</b></p>
                    <p>Анализ почв на содержание тяжелых металлов — основа для <b>заключения о
                        пригодности/безопасности
                        почвы для ведения на ней сельскохозяйственного производства</b></p>
                </div>
            ),
        image: <img height={250} src={soilImage} alt={'soil'}/>,
    },
    [ActivityTypes.greenMass]:
        {
            heading: 'Зеленая масса растений/корма',
            directionsCount: <><span style={{fontWeight: 800}}>7</span> направлений анализа</>,
            determinedIndicators:
                [
                    'Содержание микроэлементов (Zn, Cu, Mn, Co, B, Mo)',
                    'Содержание макроэлементов (N, P, K)',
                    'Содержание мезоэлементов (Ca, Mg, S)',
                    'Содержание сухого вещества',
                    'Содержание сырой золы',
                    'Содержание тяжелых металлов (Pb, Cd, Hg, Ni, Sn, V, Sb, As)',
                ],
            type:
                'green',
            text:
                (
                    <div style={{display: 'flex', flexDirection: 'column', gap: '32px'}}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '104px',
                        }}>
                            <p>Для своевременного определения недостатка того или иного элемента питания и
                                оперативной
                                корректировки системы применения удобрений <b>необходимо производить анализ зеленой
                                    массы
                                    растений</b></p>
                            <p>Быстрое регулирование уровня содержания макро-, мезо- и микроэлементов позволяет <b>избежать
                                снижения урожайности при меняющихся факторах сельско-хозяйственного производства</b>
                            </p>
                        </div>
                        <p>Для составления правильного рациона животных <b>необходимо знать питательную ценность
                            корма и
                            быть уверенным в его безопасности</b></p>
                    </div>
                ),
            image: <img height={266} src={greenMassImage} alt={'green mass'}/>,
        }
    ,
    [ActivityTypes.organicFertilizers]:
        {
            heading: 'Органические удобрения',
            directionsCount: <><span style={{fontWeight: 800}}>4</span> направления анализа</>,
            determinedIndicators:
                [
                    'Содержание микроэлементов (Zn, Cu, Mn, Co, B, Mo)',
                    'Содержание макроэлементов (N, P, K)',
                    'Содержание мезоэлементов (Ca, Mg, S)',
                    'Содержание сухого вещества и сырой золы',
                    'Содержание тяжелых металлов (Pb, Cd, Hg, Ni, Sn, V, Sb, As)',
                    'Содержание общего аммонийного азота, фосфора, калия',
                    'pH',
                ],
            type:
                'yellow',
            image: <img height={406} src={organicFertilizersImage} alt={'organic fertilizers'}/>,
        }
    ,
    [ActivityTypes.water]: {
        heading: 'Поливные воды',
        directionsCount: <><span style={{fontWeight: 800}}>8</span> направлений анализа</>,
        determinedIndicators:
            [
                'Содержание металлов (Al, As, B, Ba, Be, Bi, Cd, Co, Cr, Ca, Cu, Fe, K, Mg, Mn, Mo, Na, Ni, Pb, Sb, Se, Sn, Si, Sr, Ti, Te, Li, V, W, Zn)',
                'Фосфор',
                'Содержание нитратов, сульфатов, хлоридов',
                'Щёлочность',
                'Электропроводность',
                'pH',
                'Сера',
                'Аммонийный азот',
            ],
        type:
            'blue',
        text:
            <p>Анализ поливных вод является необходимым для произведения <b>точных расчетов рецептов питательных
                растворов</b></p>,
        image: <img height={398} src={waterImage} alt={'water'}/>,
    },
};